<template>
  <div :class="{ 'pb-mobile-nav': smAndDown }">
    <v-row justify="space-between" align="center" class="ma-0">
      <v-breadcrumbs :items="crumbs" divider="/"></v-breadcrumbs>
      <v-btn v-if="notifications.length > 0" variant="text" @click="markAllRead">mark all as read</v-btn>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        <v-card :elevation="1">
          <v-card-text>
            <v-list v-if="notifications.length > 0" :lines="smAndDown ? 'three' : 'two'">
              <v-list-item
                v-for="notification in notifications"
                :key="notification.id"
                :class="{ 'bg-grey-lighten-4': !notification.is_read }"
                @click="markRead(notification)"
              >
                <template v-slot:prepend>
                  <v-icon :color="notification.is_read ? 'grey' : 'primary'">
                    {{ notification.type === 'price_alert' ? 'mdi-chart-line' : 'mdi-bell-outline' }}
                  </v-icon>
                </template>
                <v-list-item-title :class="{ 'font-weight-bold': !notification.is_read }">
                  {{ notification.title }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ notification.message }}
                  <span v-if="smAndDown" class="text-caption text-grey d-block mt-1">
                    {{ formatDate(notification.created) }}
                  </span>
                </v-list-item-subtitle>
                <template v-slot:append>
                  <div class="d-flex align-center">
                    <span v-if="!smAndDown" class="text-caption text-grey mr-4">{{ formatDate(notification.created) }}</span>
                    <v-btn icon="mdi-delete-outline" variant="text" size="small" @click.stop="deleteNotification(notification.id)"></v-btn>
                  </div>
                </template>
              </v-list-item>
            </v-list>
            <div v-else class="text-center pa-8">
              <v-icon size="64" color="grey-lighten-1">mdi-bell-off-outline</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex';
import { useDisplay } from 'vuetify';

export default {
  setup() {
    const { smAndDown } = useDisplay();
    return { smAndDown };
  },
  data() {
    return {
      notifications: []
    };
  },
  async created() {
    this.getNotifications();
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    crumbs() {
      return [
        {
          title: 'notifications',
          disabled: true,
          href: ''
        },
      ];
    },
  },
  methods: {
    ...mapMutations(["showSnackbar", "bumpNotificationChange"]),
    async getNotifications() {
      try {
        const response = await axios.get('/notifications/');
        this.notifications = response.data;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load notifications' });
      }
    },
    async markRead(notification) {
      try {
        if (notification.is_read) {
          await axios.patch(`/notifications/${notification.id}/unread`);
          notification.is_read = false;
        } else {
          await axios.patch(`/notifications/${notification.id}/read`);
          notification.is_read = true;
        }
        this.bumpNotificationChange();
      } catch (error) {
        this.showSnackbar({ message: 'Failed to update notification' });
      }
    },
    async markAllRead() {
      try {
        await axios.patch('/notifications/read');
        this.notifications.forEach(n => n.is_read = true);
        this.bumpNotificationChange();
      } catch (error) {
        this.showSnackbar({ message: 'Failed to mark all as read' });
      }
    },
    async deleteNotification(id) {
      try {
        await axios.delete(`/notifications/${id}`);
        this.notifications = this.notifications.filter(n => n.id !== id);
        this.bumpNotificationChange();
      } catch (error) {
        this.showSnackbar({ message: 'Failed to delete notification' });
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' });
    }
  }
};
</script>

<style scoped>
:deep(.v-list-item-title) {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}
@media (max-width: 600px) {
  :deep(.v-list-item__spacer) {
    width: 8px;
  }
}
.pb-mobile-nav {
  padding-bottom: calc(56px + env(safe-area-inset-bottom));
}
</style>
